export const save = (value) => {
  localStorage.setItem('isSubscribed', value);
};

export const get = () => localStorage.getItem('isSubscribed') === 'true';
